const SUPABASE_URL = "https://bywsyoscrcpuyunqyqpe.supabase.co";
const SUPABASE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ5d3N5b3NjcmNwdXl1bnF5cXBlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODAzOTk3NzgsImV4cCI6MjA5NTk3NTc3OH0.JA0FGJZW6wNpiPEtLo3FqXhrs0tVHBXijDhMPjLKBYc";

const headers = {
  "apikey": SUPABASE_KEY,
  "Authorization": "Bearer " + SUPABASE_KEY,
  "Content-Type": "application/json",
  "Prefer": "return=minimal"
};

async function supabase(table, method = "GET", body = null, query = "") {
  const res = await fetch(SUPABASE_URL + "/rest/v1/" + table + query, {
    method,
    headers,
    body: body ? JSON.stringify(body) : null
  });
  if (method === "GET") return res.json();
  return res.ok;
}

export async function getEmployees() {
  return supabase("employees", "GET", null, "?select=*&order=id");
}

export async function saveSale(sale) {
  return supabase("sales", "POST", {
    id: sale.id || Date.now(),
    date: sale.date,
    time: sale.time,
    employee_name: sale.employeeName,
    category: sale.category,
    description: sale.description || "",
    price: Number(sale.price),
    payment: sale.payment
  });
}

export async function saveAttendance(data) {
  return supabase("attendance", "POST", {
    id: Date.now(),
    date: data.date,
    employee_name: data.employeeName,
    start_time: data.startTime,
    end_time: data.endTime,
    hours: Number(data.hours)
  });
}

export async function saveEmployee(data) {
  if (data.action === "add") {
    return supabase("employees", "POST", {
      id: data.id,
      name: data.name,
      pin: data.pin,
      color: data.color || "#4ECDC4"
    });
  } else if (data.action === "delete") {
    return supabase("employees", "DELETE", null, "?id=eq." + data.id);
  }
}

export async function saveMeldung(data) {
  return supabase("meldungen", "POST", {
    id: Date.now(),
    date: data.date,
    time: data.time,
    employee_name: data.employeeName,
    bar_total: Number(data.barTotal),
    note: data.note
  });
}

export async function getReport() {
  const [sales, attendance, meldungen] = await Promise.all([
    supabase("sales", "GET", null, "?select=*&order=created_at"),
    supabase("attendance", "GET", null, "?select=*&order=id"),
    supabase("meldungen", "GET", null, "?select=*&order=id")
  ]);
  return {
    sales: sales.map(s => ({...s, employeeName: s.employee_name, startTime: s.start_time, endTime: s.end_time})),
    attendance: attendance.map(a => ({...a, employeeName: a.employee_name, startTime: a.start_time, endTime: a.end_time})),
    meldungen: meldungen.map(m => ({...m, employeeName: m.employee_name, barTotal: m.bar_total}))
  };
}

export async function getOnline() {
  const today = new Date().toLocaleDateString("de-DE");
  const data = await supabase("attendance", "GET", null, "?select=*&date=eq." + today + "&end_time=eq.");
  return { online: data.map(a => ({ employeeName: a.employee_name, startTime: a.start_time })) };
}

export async function saveCheckIn(data) {
  const today = new Date().toLocaleDateString("de-DE");
  const existing = await supabase("attendance", "GET", null, "?date=eq." + today + "&employee_name=eq." + encodeURIComponent(data.employeeName) + "&end_time=eq.");
  if (existing.length > 0) return { status: "already_online", startTime: existing[0].start_time };
  const online = await supabase("attendance", "GET", null, "?date=eq." + today + "&end_time=eq.");
  if (online.length > 0) return { status: "blocked", message: "Another employee is online" };
  await supabase("attendance", "POST", {
    id: Date.now(),
    date: data.date,
    employee_name: data.employeeName,
    start_time: data.startTime,
    end_time: "",
    hours: 0
  });
  return { status: "ok" };
}

export async function saveCheckOut(data) {
  const today = new Date().toLocaleDateString("de-DE");
  const records = await supabase("attendance", "GET", null, "?date=eq." + today + "&employee_name=eq." + encodeURIComponent(data.employeeName) + "&end_time=eq.&order=id.desc&limit=1");
  if (records.length > 0) {
    await supabase("attendance", "PATCH", {
      end_time: data.endTime,
      hours: Number(data.hours)
    }, "?id=eq." + records[0].id);
  }
}

export async function getBarToday() {
  const today = new Date().toLocaleDateString("de-DE");
  const sales = await supabase("sales", "GET", null, "?date=eq." + today + "&payment=eq.Bar&select=price");
  const total = sales.reduce((sum, s) => sum + Number(s.price), 0);
  return { barTotal: total };
}

export async function getLastCheckout() {
  const today = new Date().toLocaleDateString("de-DE");
  const records = await supabase("attendance", "GET", null, "?date=eq." + today + "&end_time=neq.&order=id.desc&limit=1");
  if (records.length > 0 && records[0].end_time) {
    return { lastEndTime: records[0].end_time };
  }
  return { lastEndTime: "10:00" };
}

export async function checkExtraAllowed(employeeName) {
  const today = new Date().toLocaleDateString("de-DE");
  const key = "allow_extra_" + employeeName.trim() + "_" + today;
  try { return { allowed: localStorage.getItem(key) === "true" }; } catch(e) { return { allowed: false }; }
}

export async function consumeExtraShift(employeeName) {
  const today = new Date().toLocaleDateString("de-DE");
  const key = "allow_extra_" + employeeName.trim() + "_" + today;
  try { localStorage.removeItem(key); } catch(e) {}
}

export async function allowExtraShift(employeeName) {
  const today = new Date().toLocaleDateString("de-DE");
  const key = "allow_extra_" + employeeName.trim() + "_" + today;
  try { localStorage.setItem(key, "true"); } catch(e) {}
}

export async function processQueue() {
  try {
    const queue = JSON.parse(localStorage.getItem("xbent_queue") || "[]");
    if (queue.length === 0) return;
    const remaining = [];
    for (const item of queue) {
      try { await fetch(item.url, item.options); } catch(e) { remaining.push(item); }
    }
    localStorage.setItem("xbent_queue", JSON.stringify(remaining));
  } catch(e) {}
}

export async function getShoppingList() {
  return supabase("shopping_list", "GET", null, "?select=*&order=id.desc");
}

export async function saveShoppingItem(data) {
  return supabase("shopping_list", "POST", {
    id: Date.now(),
    date: data.date,
    time: data.time,
    employee_name: data.employeeName,
    category: data.category,
    product: data.product,
    note: data.note || "",
    done: false
  });
}

export async function markShoppingDone(id) {
  return supabase("shopping_list", "PATCH", { done: true }, "?id=eq." + id);
}

export async function deleteShoppingItem(id) {
  return supabase("shopping_list", "DELETE", null, "?id=eq." + id);
}

export async function setAllowExtraDB(employeeName) {
  const today = new Date().toLocaleDateString("de-DE");
  await supabase("allow_extra", "DELETE", null, "?employee_name=eq." + encodeURIComponent(employeeName));
  return supabase("allow_extra", "POST", { employee_name: employeeName, date: today });
}

export async function checkAllowExtraDB(employeeName) {
  const today = new Date().toLocaleDateString("de-DE");
  const data = await supabase("allow_extra", "GET", null, "?employee_name=eq." + encodeURIComponent(employeeName) + "&date=eq." + today);
  return { allowed: data.length > 0 };
}

export async function removeAllowExtraDB(employeeName) {
  return supabase("allow_extra", "DELETE", null, "?employee_name=eq." + encodeURIComponent(employeeName));
}
